import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { gross, isPro, lei, resale, shortName } from "@/lib/pricing";
import ProductSheet from "./ProductSheet";

const Thumb = ({ p }) => <div className="pl-thumb">{p.image && <img src={p.image} alt={p.name} loading="lazy" />}</div>;

export const useProductSheet = (data, track) => {
  const [open, setOpen] = useState(null);
  const show = (p) => {
    setOpen(p);
    track?.("open", p.id);
  };
  return [show, <ProductSheet p={open} data={data} onClose={() => setOpen(null)} track={track} />];
};

export default function PriceList({ data, track }) {
  const [show, sheet] = useProductSheet(data, track);
  return (
    <section className="pub-section" data-testid="section-lista">
      <header className="pub-sec-head">
        <span className="pub-eyebrow">Prețuri pentru saloane</span>
        <h2>Listă de preț</h2>
        <p>Prețuri profesionale în lei, cu TVA {data.vat}% inclus. <span className="pl-legend">Auriu = preț recomandat de revânzare</span>. Atinge un produs pentru detalii.</p>
      </header>
      <ul className="pl-list">
        {data.products.map((p, i) => (
          <li key={p.id} className="pl-row pl-row--tap" role="button" tabIndex={0} onClick={() => show(p)} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), show(p))} data-testid={`pricelist-row-${p.id}`}>
            <Thumb p={p} />
            <div className="pl-info">
              <span className="pl-idx">{String(i + 1).padStart(2, "0")} · cod {p.code}</span>
              <b>{shortName(p.name)}</b>
              <span className="pl-size">{p.size}</span>
            </div>
            <div className="pl-price" data-testid={`pricelist-price-${p.id}`}>
              <b>{lei(gross(p.price, data.vat))}</b>
              <span>preț salon</span>
              {isPro(data, p.id)
                ? <small>uz profesional</small>
                : <small className="pl-resale" data-testid={`pricelist-resale-${p.id}`}>revânzare {lei(resale(p.price, data.markup, data.vat))}</small>}
            </div>
            <ChevronRight size={16} className="pl-chev" />
          </li>
        ))}
      </ul>
      {sheet}
    </section>
  );
}

export { Thumb };
